import React, { useRef, useEffect, useState } from "react";

const sitemap = [
  {
    label: "UtahData (Home)",
    path: "/",
    children: [
      {
        label: "Utah Verticals",
        path: "/verticals",
        children: [
          { label: "Manufacturing", path: "/verticals/manufacturing" },
          { label: "Information", path: "/verticals/information" },
          { label: "Engineering & Technology", path: "/verticals/engineering-and-technology" },
          { label: "Food Industry", path: "/verticals/food" },
          { label: "Aerospace", path: "/verticals/aerospace" },
          { label: "BFM (Business Finance Marketing)", path: "/verticals/business-finance-marketing" },
        ],
      },
      {
        label: "Utah At a Glance",
        path: "/utah-at-a-glance",
        children: [
          { label: "Charging Stations", path: "/utah-at-a-glance/charging-stations" },
          { label: "Utah Housing", path: "/utah-at-a-glance/utah-housing" },
          { label: "Utah Counties", path: "/utah-at-a-glance/utah-counties" },
          { label: "Utah State", path: "/utah-at-a-glance/utah-state" },
          { label: "Utah Voters Count", path: "/utah-at-a-glance/utah-voters-count" },
          {
            label: "Education & Resources",
            path: "/utah-at-a-glance/education-and-intellectual-resources",
            children: [
              { label: "Utah Universities", path: "/utah-at-a-glance/education-and-intellectual-resources/utah-universities" },
              { label: "Utah Schools", path: "/utah-at-a-glance/education-and-intellectual-resources/utah-schools" },
            ],
          },
          { label: "Utah Cities", path: "/utah-at-a-glance/utah-cities" },
          { label: "Demographics", path: "/utah-at-a-glance/demographics" },
          { label: "Jobs", path: "/utah-at-a-glance/jobs" },
          { label: "Geothermal", path: "/utah-at-a-glance/geothermal" },
          { label: "Airports", path: "/utah-at-a-glance/airports" },
          { label: "MLM", path: "/utah-at-a-glance/mlm" },
          { label: "Hospital", path: "/utah-at-a-glance/hospitals" },
          { label: "Air Quality", path: "/utah-at-a-glance/air-quality" },
          { label: "Tax", path: "/utah-at-a-glance/tax" },
          { label: "Zipcode", path: "/utah-at-a-glance/zipcodes" },
        ],
      },
      {
        label: "Other Pages",
        path: "",
        children: [
          { label: "Login", path: "/login" },
          { label: "About", path: "/about" },
          { label: "Privacy Policy", path: "/privacy-policy" },
          { label: "Contact Us", path: "/contact-us" },
          { label: "Gallery", path: "/gallery" },
          { label: "KCG", path: "/kcg" },
          { label: "Ask Betsy AI", path: "/betsy" },
          { label: "Naics", path: "/get-naics" },
          { label: "Copyright", path: "/copyright" },
          { label: "WIP", path: "/wip" },
        ],
      },
    ],
  },
];

const TreeNode = ({ node, level = 0, parentRef, onLineDraw }) => {
  const ref = useRef();

  useEffect(() => {
    if (ref.current && parentRef?.current) {
      const parentBox = parentRef.current.getBoundingClientRect();
      const childBox = ref.current.getBoundingClientRect();

      const startX = parentBox.left + parentBox.width / 2;
      const startY = parentBox.bottom;
      const endX = childBox.left + childBox.width / 2;
      const endY = childBox.top;

      onLineDraw({
        startX,
        startY,
        endX,
        endY,
      });
    }
  }, [ref.current]);
  const navigatetopage = () => {
    if (node.path) {
      window.location.href = node.path;
    } else {      
      console.warn("No path defined for node:", node.label);
    }
  };
  return (
    <div className="flex flex-col items-center relative">
      <div
        ref={ref}
        className={`rounded px-4 py-2 mb-4 font-medium shadow-md text-center whitespace-nowrap onhover:shadow-lg transition-all duration-300 cursor-pointer
        ${level === 0 ? "bg-blue-500 text-white" :
          level === 1 ? "bg-purple-400 text-white" :
            "bg-white border border-gray-400"}`}
            onClick={navigatetopage}
      >
        {node.label}
      </div>

      {node.children && (
        <div className="flex gap-8 flex-wrap justify-center">
          {node.children.map((child, i) => (
            <TreeNode
              key={i}
              node={child}
              level={level + 1}
              parentRef={ref}
              onLineDraw={onLineDraw}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const SiteMapPage = () => {
  const [lines, setLines] = useState([]);
  const containerRef = useRef();

  const handleLineDraw = (line) => {
    setLines((prev) => [...prev, line]);
  };

  return (
    <div ref={containerRef} className="relative overflow-auto min-h-screen bg-gray-50 p-10">
      {/* <h2 className=" text-3xl font-semibold mb-10">Sitemap Tree</h2> */}
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-white py-12">
         <header className="fixed top-0 left-0 w-full header z-20">
        <a href="/">
        <img
          src="/img/headerlogo.png"
          alt="Utah Data Logo"
          className="logo"
   
        /></a>
       
      </header>
    <div className="sitemap-container">
      <h2 className="text-center sitemap-title mb-5">Website Sitemap</h2>
      {/* Main tree */}
      <div className="relative z-10">
        {sitemap.map((node, i) => (
          <TreeNode key={i} node={node} level={0} onLineDraw={handleLineDraw} />
        ))}
      </div>

   
    </div>
    </div>
    </div>
  );
};

export default SiteMapPage;
